import callAPiBase from './base';

const synopticApi = {
  monitoringList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/monitoringList',
      method: 'GET',
      useToken: true,
      title: 'Synoptic - Monitoring List',
      params,
    }),
};

export { synopticApi };
export default synopticApi;
